import App from './App.vue'
import { createApp } from 'vue'
import * as Sentry from "@sentry/vue"
import { BrowserTracing } from "@sentry/tracing"

const peopleProfiles = document.querySelector("#people-profiles");

// Verify that the people profiles element exists
if (peopleProfiles) {

  // Create Vue application
  const app = createApp(App, {
    requestedProfiles: peopleProfiles.textContent
  });

  // Initalise Sentry error reporting
  Sentry.init({
    app,
    dsn: 'https://33b488c3883048e0a4a5ed45b225304f@o1297979.ingest.sentry.io/4503919497445376',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.25,
  });

  // Mount application
  app.mount(peopleProfiles)
}